import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
//@ts-ignore
const WarehouseList = () => {
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Contact No.",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "primary_email",
      cell: NACell,
    },
    {
      header: "Landmark",
      accessorKey: "landmark",
      cell: NACell,
    },
    {
      header: "Warehouse Manager",
      accessorKey: "warehouse_manager.name",
      cell: NACell,
    },
  ];
  return (
    <DataTable
      url={APIS.WAREHOUSE}
      queryKey={"warehouse"}
      columns={defaultColumns}
      addNewPagePath={"/create"}
      tableName={"warehouse"}
    />
  );
};

export default WarehouseList;
